/**
 * The Teams page's tabs, as their path segments (#6718): the teams on running work, and the templates a
 * reader keeps. Which teams the first lists is its perspective chips' job; the template archive is the
 * second's Archived chip. Neither is a tab.
 */
export enum PageTab {
  Teams = 'teams',
  Templates = 'templates'
}
